// service.js
import DataService from "../dataService";
import api from "../api";


const getTeam = async () => {
    try {
        const response = await DataService.get(api.teamApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getteam';
    }
};


export {
    getTeam
};